
import Logout from "./Logout"

export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const refreshToken = async () => {
  try {
    //const token = localStorage.getItem('token');        
    const response = await fetch('https://kast-server-713b1c89d478.herokuapp.com/api/auth/refresh-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token })
    });
    
    if (!response.ok) throw new Error('Refresh failed');
    const { token } = await response.json();
    return token;
  } catch (error) {
    console.error('Token refresh failed:', error);
    return null;
  }
};

// Add this new function to check auth state periodically
export const initAuthState = (navigate) => {
  // Check auth state every 10 minutes
  const interval = setInterval(async () => {
    const token = localStorage.getItem('token');
    if (token && isTokenExpired(token)) {
      const newToken = await refreshToken();
      if (!newToken) {
        Logout(navigate);
        clearInterval(interval);
      }
    }
  }, 10 * 60 * 1000); // 10 minutes
  
  return () => clearInterval(interval);
};

export const verifyAuth = async () => {
  const token = localStorage.getItem('token');
  if (!token) return false;
  
  if (isTokenExpired(token)) {
    const newToken = await refreshToken();
    if (!newToken) return false;
    localStorage.setItem('token', newToken);
  }
  
  return true;
};